<template>
    <footer class="footer">
      <b-container>
        <b-row>
          <b-col cols="12" md="4">
            <a href="http://www.remstalkellerei.de" target="_blank"><img src="../assets/footer/remstalkellerei.png" alt="Remstalkellerei"></a>
          </b-col>
          <b-col cols="12" md="4">
            <a href="http://www.weintreff-neuekelter.de" target="_blank"><img src="../assets/footer/weintreff.png" alt="Weintreff Neue Kelter"></a>
          </b-col>
          <b-col cols="12" md="4">
            <a href="http://www.remstal-route.de" target="_blank"><img src="../assets/footer/remstalroute.png" alt="Remstalroute"></a>
          </b-col>
          <!-- <b-col cols="12" md="3">
            <a href="https://www.facebook.com/WbvRemshalden" target="_blank"><img src="../assets/footer/facebook.png" alt="Facebook"></a>
          </b-col> -->
        </b-row>
      </b-container>
    </footer>
</template>

<script>
export default {
  name: 'globalFooter',
  components: {
  }
}
</script>

<style lang="scss" scoped>
    .footer {
      background-color: $weinprobe-red;
      padding: 20px;
      margin-top: 25px;
      text-align: center;
    }

    img {
      margin-bottom: 1em;
    }
</style>
